var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWealth = function SvgWealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".wealth_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.004 7.5v-1M13.5 7.5h-2.029a1.342 1.342 0 0 0-.5 2.587l2.064.826a1.342 1.342 0 0 1-.5 2.587H10.5M12.004 14.5v-1M1.437 14.909C3.651 17.064 7.55 18.5 12 18.5s8.353-1.435 10.567-3.59",
    className: "wealth_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.023 17.548C21.122 12.334 16.031.5 12 .5S2.88 12.333 5.98 17.548",
    className: "wealth_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.067 12.445C2.589 13.267 1 14.621 1 16.5c0 4.5 4.925 7 11 7s11-2.5 11-7c0-1.879-1.585-3.233-4.063-4.055",
    className: "wealth_svg__a"
  })));
};
export default SvgWealth;